"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeSwitcherContext = void 0;
var _react = require("react");
var _constants = require("./constants");
var ThemeSwitcherContext = exports.ThemeSwitcherContext = /*#__PURE__*/(0, _react.createContext)({
  activeThemeId: _constants.SYSTEM_THEME_ID,
  theme: null,
  setActiveThemeId: function setActiveThemeId() {}
});